import { createContext, useContext } from 'react';
import { StaffMember } from '@/types/api/staffMember';

type StaffMemberInfoContext = {
  staffMember?: StaffMember;
  directLeader?: StaffMember;
  refreshUser?: () => void;
};

const staffMemberInfoContext = createContext<StaffMemberInfoContext>({});

export const useStaffMemberInfoContext = (): ReturnType<
  typeof useContext<StaffMemberInfoContext>
> => useContext(staffMemberInfoContext);

export default staffMemberInfoContext;
